import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ExploreMapUiService {
  private expandedMapOpen = false;
  private readonly closeRequest$ = new Subject<void>();

  readonly expandedMapCloseRequested$ = this.closeRequest$.asObservable();

  setExpandedMapOpen(open: boolean): void {
    this.expandedMapOpen = open;
  }

  isExpandedMapOpen(): boolean {
    return this.expandedMapOpen;
  }

  requestCloseExpandedMap(): void {
    if (!this.expandedMapOpen) {
      return;
    }

    this.closeRequest$.next();
  }
}
